/**
 * Esquemas de los parámetros de búsqueda del bloque de nutrición.
 *
 * Como en el catálogo de ejercicios, cada campo lleva `catch(undefined)`: una
 * URL escrita a mano o de una versión anterior no debe tumbar la pantalla, sólo
 * perder ese parámetro y caer en el valor por defecto.
 */
import { z } from 'zod';

/** `YYYY-MM-DD`, el día del diario. */
const isoDate = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .optional()
  .catch(undefined);

const mealType = z
  .enum(['breakfast', 'lunch', 'dinner', 'snack', 'other'])
  .optional()
  .catch(undefined);

/** `/food?date=` */
export const foodDateSchema = z.object({ date: isoDate, meal: mealType });
export type FoodDateSearch = z.infer<typeof foodDateSchema>;

/** `/food/add?date=&meal=` y `/food/scan?date=&meal=` */
export const foodAddSchema = z.object({ date: isoDate, meal: mealType });
export type FoodAddSearch = z.infer<typeof foodAddSchema>;

/** `/food/foods/new?barcode=` */
export const newFoodSchema = z.object({
  barcode: z.string().max(32).optional().catch(undefined),
  date: isoDate,
  meal: mealType,
});
export type NewFoodSearch = z.infer<typeof newFoodSchema>;

/** `/food/foods/$id?date=&meal=`: al venir del escáner se conserva el destino. */
export const foodDetailSchema = z.object({ date: isoDate, meal: mealType });
export type FoodDetailSearch = z.infer<typeof foodDetailSchema>;

/** `/food/trends?days=` */
export const TREND_RANGES = [7, 14, 30] as const;
export type TrendDays = (typeof TREND_RANGES)[number];
export const trendsSchema = z.object({
  days: z
    .union([z.literal(7), z.literal(14), z.literal(30)])
    .optional()
    .catch(undefined),
});
export type TrendsSearch = z.infer<typeof trendsSchema>;
